import React, { useEffect, useState } from 'react';
import {
  Box, TextField, Container, Grid, Card, CardContent, Divider, Button, Tab, Tabs, FormControl, InputLabel, MenuItem, Select, IconButton, Typography,SelectChangeEvent
} from '@mui/material';
import { Helmet } from 'react-helmet-async';
import axios from 'axios';
import DeleteIcon from '@mui/icons-material/Delete';

import AddIcon from '@mui/icons-material/Add';


const AddAudio = ({ handleClose }) => {
  const [tabValue, setTabValue] = useState(0);
  const [packages, setPackages] = useState([]);
  const [selectedPackage, setSelectedPackage] = useState('');
  const [categories, setCategories] = useState([]);
  const [posterFile, setPosterFile] = useState(null);
  const [posterPreview, setPosterPreview] = useState('');
  const [landscapePosterFile, setLandscapePosterFile] = useState(null);
  const [landscapePosterPreview, setLandscapePosterPreview] = useState('');

  const [broadPosterFile, setBroadPosterFile] = useState(null);
  const [broadPosterPreview, setBroadPosterPreview] = useState('');


  const [languages, setLanguages] = useState([]);
  const [selectedLanguage, setSelectedLanguage] = useState('');
  const [tracks, setTracks] = useState([]);

  const [trailers, setTrailers] = useState([
    { Bitrate: '', url: '', audioTitle: '', qualityTitle: '', serverURL: '', order: '',subtitles:[] },
  ]);
  
  const [commonValues, setCommonValues] = useState({
    enable: '',
    title: '',
    description: '',
    poster: '',
    landscapePoster: '',
    broadPoster: '',
    disableCommenting: '',
    order: '',
    parentFolder: '',
    packages: '',
    mainCategory: '',
    additionalCategory: '',
  });


  

  const [metadataValues, setMetadataValues] = useState({
    productionCompany :'',
    artist :'',
    language :'',
    year :'',
    month :'',
    day :'',
    price :'',
    purchaseDuration :'',
    tags: [],
  });

  // Function to handle metadata change
  const handleMetadataChange = (id, value) => {
    setMetadataValues((prevMetadata) => ({
      ...prevMetadata,
      [id]: value,
    }));
  };
  
  
  // Generate arrays for days, months, and years
  const generateDays = () => Array.from({ length: 31 }, (_, i) => ({ value: (i + 1).toString(), label: (i + 1).toString() }));
  const generateMonths = () => [
    { value: 'January', label: 'January' },
    { value: 'February', label: 'February' },
    { value: 'March', label: 'March' },
    { value: 'April', label: 'April' },
    { value: 'May', label: 'May' },
    { value: 'June', label: 'June' },
    { value: 'July', label: 'July' },
    { value: 'August', label: 'August' },
    { value: 'September', label: 'September' },
    { value: 'October', label: 'October' },
    { value: 'November', label: 'November' },
    { value: 'December', label: 'December' },
  ];
  
  const generateYears = () => {
    const currentYear = new Date().getFullYear();
    return Array.from({ length: currentYear - 1900 + 1 }, (_, i) => ({
      value: (currentYear - i).toString(),
      label: (currentYear - i).toString(),
    }));
  };

  const days = generateDays();
  const months = generateMonths();
  const years = generateYears();
  const handleTagsChange = (e) => {
    const { value } = e.target;
    const tagsArray = value.split(',').map((tag) => tag.trim());
    setMetadataValues((prevMetadata) => ({
      ...prevMetadata,
      tags: tagsArray,
    }));
  };
  








  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const handleCommonChange = (id, value) => {
    setCommonValues({ ...commonValues, [id]: value });
  };
  

  // Function to handle poster image change
  const handlePosterChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        const result = reader.result; // This is of type ArrayBuffer
        if (typeof result === 'string') {
          setPosterPreview(result);
        }
      };
      reader.readAsDataURL(file);
      setPosterFile(file);
    }
  };

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>, id: string) => {
    handleMetadataChange(id, event.target.value);
  };
  

 // Function to handle Landscape Poster change
  const handleLandscapePosterChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        const result = reader.result;
        if (typeof result === 'string') {
          setLandscapePosterPreview(result);
        }
      };
      reader.readAsDataURL(file);
      setLandscapePosterFile(file);
    }
  };
   // Function to handle Broad Poster change
  const handleBroadPosterChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        const result = reader.result;
        if (typeof result === 'string') {
          setBroadPosterPreview(result);
        }
      };
      reader.readAsDataURL(file);
      setBroadPosterFile(file);
    }
  };



  const handleAddTrack = () => {
    const newTracks = [
      ...tracks,
      { title: '', url: '', duration: '', order: '' },
    ];
    setTracks(newTracks);
  };
  
  const handleDeleteTrack = (index) => {
    const updatedTracks = [...tracks];
    updatedTracks.splice(index, 1);
    setTracks(updatedTracks);
  };
  
  const handleTrackChange = (index, updatedField) => {
    const updatedTracks = [...tracks];
    updatedTracks[index] = { ...updatedTracks[index], ...updatedField };
    setTracks(updatedTracks);
  };
  
 
  
/*Handle the dropdown for language and status */

useEffect(() => {
  fetchLanguages();
}, []);

const fetchLanguages = async () => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_BASE_API_URL}${process.env.REACT_APP_LANGUAGES}`);
    console.log('Languages Response:', response); // Log the response object
    if (Array.isArray(response.data)) {
      setLanguages(response.data);
    } else {
      console.error('Invalid data format for languages:', response.data);
    }
  } catch (error) {
    console.error('Error fetching languages:', error);
  }
};



 
  const handleSubmit = async () => {
    // Handle submission logic based on tab values
  };


  
/*fetch channel List*/
useEffect(() => {
  fetchPackages();
}, []);

const fetchPackages = async () => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_BASE_API_URL}${process.env.REACT_APP_PACKAGE}`);
    if (Array.isArray(response.data)) {
      setPackages(response.data);
    } else {
      console.error('Invalid data format for packages:', response.data);
      // Handle this case according to your specific requirements
    }
  } catch (error) {
    console.error('Error fetching packages:', error);
    // Handle error, show message, etc.
  }
};
useEffect(() => {
  fetchCategories();
}, []);

//fetch categories 
const fetchCategories = async () => {
  try {
    const response = await axios.get(`${process.env.REACT_APP_BASE_API_URL}${process.env.REACT_APP_CATEGORY}`);
    console.log(response.data); // Check the structure of response.data

    if (Array.isArray(response.data.applications)) {
      const categoryIds = response.data.applications.map(app => app.id);
      setCategories(categoryIds);
    } else {
      console.error('Invalid data format:', response.data);
      
    }
  } catch (error) {
    console.error('Error fetching categories:', error);
    
  }
};





  return (
    <>
      <Helmet>
        <title>Advertisement Page</title>
      </Helmet>
      <Container maxWidth="lg" sx={{ marginTop: '20px' }}>
      <Grid container justifyContent="center">

      <Grid item xs={12} md={12}>
      <Card variant="outlined">
              {/* <Divider /> */}
              <CardContent>
                <Box sx={{ marginBottom: '20px' }}>
                  <Tabs value={tabValue} onChange={handleTabChange}>
                    <Tab label="Common" />
                    <Tab label="Metadata" />
                    <Tab label="Trailers" />
                  </Tabs>
                  </Box>
                  {/* Common Tab */}
                 

                  {tabValue === 0 && (
                    <Box mt={3}>
                    <Grid container spacing={2}>
                       <Grid item xs={12} sm={6}>
                        <FormControl fullWidth>
                          <InputLabel id="enable-label">Enable</InputLabel>
                          <Select
                              labelId="enable-label"
                              id="enable"
                              value={commonValues.enable}
                              onChange={(e) => handleCommonChange('enable', e.target.value)}
                            >
                              <MenuItem value="Yes">Yes</MenuItem>
                              <MenuItem value="No">No</MenuItem>
                            </Select>
                           </FormControl>
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <TextField
                          id="title"
                          label="Title"
                          value={commonValues.title}
                          onChange={(e) => handleCommonChange('title', e.target.value)}

                          fullWidth
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                      {/* Poster Image Upload */}
                                <input
                                  type="file"
                                  accept="image/*"
                                  id="posterUpload"
                                  onChange={handlePosterChange}
                                  style={{ display: 'none' }}
                                />
                                <label htmlFor="posterUpload">
                                  <Button
                                    variant="outlined"
                                    component="span"
                                    color="primary"
                                    sx={{ textTransform: 'none' }}
                                  >
                                    <span id="posterInputLabel">Choose Poster</span>
                                  </Button>
                                </label>
                                {/* Poster Image Preview */}
                                {posterPreview && (
                                  <img src={posterPreview} alt="Poster Preview" width="100" height="100" />
                                )}
                              </Grid>


                              {/* Landscape Poster Image Upload */}
                              <Grid item xs={12} sm={6}>
                                <input
                                  type="file"
                                  accept="image/*"
                                  id="landscapePosterUpload"
                                  onChange={handleLandscapePosterChange}
                                  style={{ display: 'none' }}
                                />
                                <label htmlFor="landscapePosterUpload">
                                  <Button
                                    variant="outlined"
                                    component="span"
                                    color="primary"
                                    sx={{ textTransform: 'none' }}
                                  >
                                    Choose Landscape Poster
                                  </Button>
                                </label>
                                {/* Landscape Poster Image Preview */}
                                {landscapePosterPreview && (
                                  <img
                                    src={landscapePosterPreview}
                                    alt="Landscape Poster Preview"
                                    width="100"
                                    height="100"
                                  />
                                )}
                              </Grid>

                              {/* Broad Poster Image Upload */}
                              <Grid item xs={12} sm={6}>
                                <input
                                  type="file"
                                  accept="image/*"
                                  id="broadPosterUpload"
                                  onChange={handleBroadPosterChange}
                                  style={{ display: 'none' }}
                                />
                                <label htmlFor="broadPosterUpload">
                                  <Button
                                    variant="outlined"
                                    component="span"
                                    color="primary"
                                    sx={{ textTransform: 'none' }}
                                  >
                                    Choose Broad Poster
                                  </Button>
                                </label>
                                {/* Broad Poster Image Preview */}
                                {broadPosterPreview && (
                                  <img
                                    src={broadPosterPreview}
                                    alt="Broad Poster Preview"
                                    width="100"
                                    height="100"
                                  />
                                )}
                              </Grid>


                      <Grid item xs={12} sm={6}>
                        <TextField
                          id="description"
                          label="Description"
                          value={commonValues.description}
                          onChange={(e) => handleCommonChange('description', e.target.value)}
                          fullWidth
                        />
                      </Grid>

                      <Grid item xs={12} sm={6}>
                        <FormControl fullWidth>
                          <InputLabel id="disableCommenting-label">Disable Commenting</InputLabel>
                          <Select
                            labelId="disableCommenting-label"
                            id="disableCommenting"
                            value={commonValues.enable}
                            onChange={(e) => handleCommonChange('disableCommenting', e.target.value)}
                          >
                            <MenuItem value="Yes">Yes</MenuItem>
                            <MenuItem value="No">No</MenuItem>
                          </Select>
                        </FormControl>
                      </Grid>

                      <Grid item xs={12} sm={6}>
                        <FormControl fullWidth>
                          <InputLabel id="parentFolder-label">Parent Folder</InputLabel>
                          <Select
                            labelId="parentFolder-label"
                            id="parentFolder"
                            value={commonValues.parentFolder}
                            onChange={(e) => handleCommonChange('parentFolder', e.target.value)}
                          >
                                  <MenuItem value="">Select Folder</MenuItem>
                                  <MenuItem value="FolderID1">Folder Name 1</MenuItem>
                                  <MenuItem value="FolderID2">Folder Name 2</MenuItem>
      
                          </Select>
                        </FormControl>
                      </Grid>

                      <Grid item xs={12} sm={6}>
                              <TextField
                                required
                                id="package"
                                name="package"
                                select
                                value={selectedPackage}
                                label="Package"
                                fullWidth
                                onChange={(e) => setSelectedPackage(e.target.value)}
                              >
                                {packages.map((pkg) => (
                                  <MenuItem key={pkg.id} value={pkg.planName}>
                                    {pkg.planName}
                                  </MenuItem>
                                ))}
                              </TextField>
                            </Grid>


                         <Grid item xs={12} sm={6}>
                        <FormControl fullWidth>
                          <InputLabel id="mainCategory-label">Main Category</InputLabel>
                          <Select
                            labelId="mainCategory-label"
                            id="mainCategory"
                            value={commonValues.mainCategory}
                            onChange={(e) => handleCommonChange('mainCategory', e.target.value)}
                          >
                                  <MenuItem value="">Select mainCategory</MenuItem>
                                  <MenuItem value="FolderID1">mainCategory 1</MenuItem>
                                  <MenuItem value="FolderID2">mainCategory 2</MenuItem>
      
                          </Select>
                        </FormControl>
                      </Grid>
                            
                            
                      <Grid item xs={12} sm={6}>
                        <FormControl fullWidth>
                          <InputLabel id="additionalCategory-label">Additional Category</InputLabel>
                          <Select
                            labelId="additionalCategory-label"
                            id="additionalCategory"
                            value={commonValues.additionalCategory}
                            onChange={(e) => handleCommonChange('additionalCategory', e.target.value)}
                          >
                                  <MenuItem value="">Select additionalCategory</MenuItem>
                                  <MenuItem value="FolderID1">additionalCategory 1</MenuItem>
                                  <MenuItem value="FolderID2">additionalCategory 2</MenuItem>
      
                          </Select>
                        </FormControl>
                      </Grid>
                      </Grid>
                    </Box>
                  )}
                      



                   
                {/* Metadata Tab */}
                {tabValue === 1 && (
                        <Box mt={3}>
                         <Grid container spacing={2}>
                         <Grid item xs={12} sm={6}>
                            
                            <TextField
                              required
                              id="language"
                              name="language"
                              select
                              value={selectedLanguage}
                              label="Language"
                              fullWidth
                              onChange={(e) => setSelectedLanguage(e.target.value)}
                            >
                              {languages.map((language) => (
                                <MenuItem key={language} value={language}>
                                {language}
                              </MenuItem>
                              ))}
                            </TextField>
                          </Grid>
    <Grid item xs={12} sm={4}>
      <FormControl fullWidth>
        <InputLabel id="day-label">Day</InputLabel>
        <Select
          labelId="day-label"
          id="day"
          value={metadataValues.day}
          onChange={(e) => handleMetadataChange('day', e.target.value)}
        >
          {days.map((day) => (
            <MenuItem key={day.value} value={day.value}>
              {day.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Grid>
    <Grid item xs={12} sm={4}>
      <FormControl fullWidth>
        <InputLabel id="month-label">Month</InputLabel>
        <Select
          labelId="month-label"
          id="month"
          value={metadataValues.month}
          onChange={(e) => handleMetadataChange('month', e.target.value)}
        >
          {months.map((month) => (
            <MenuItem key={month.value} value={month.value}>
              {month.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Grid>
    <Grid item xs={12} sm={4}>
      <FormControl fullWidth>
        <InputLabel id="year-label">Year</InputLabel>
        <Select
          labelId="year-label"
          id="year"
          value={metadataValues.year}
          onChange={(e) => handleMetadataChange('year', e.target.value)}
        >
          {years.map((year) => (
            <MenuItem key={year.value} value={year.value}>
              {year.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Grid>

    <Grid item xs={12} sm={6}>
      <TextField
        id="price"
        label="Price"
        value={metadataValues.price}
        onChange={(e) => handleInputChange(e, 'price')}
        fullWidth
      />
    </Grid>
    <Grid item xs={12} sm={6}>
      <TextField
        id="purchaseDuration"
        label="Purchase Duration"
        value={metadataValues.purchaseDuration}
        onChange={(e) => handleInputChange(e, 'purchaseDuration')}
        fullWidth
      />
    </Grid>
    <Grid item xs={12} sm={6}>
      <TextField
        id="tags"
        label="Tags"
        value={metadataValues.tags.join(', ')}
        onChange={handleTagsChange}
        fullWidth
      />
    </Grid>
  </Grid>
</Box>
   )}
                
                 {/* Tracks Tab */}
{tabValue === 2 && (
  <Grid container spacing={2}>
    {tracks.map((track, index) => (
      <Grid container item spacing={2} key={index}>
        <Box sx={{ border: '1px solid #ccc', padding: '10px', marginBottom: '20px' }}>
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <TextField
                name={`Title-${index}`}
                value={track.title}
                label="Title"
                fullWidth
                onChange={(e) => handleTrackChange(index, { title: e.target.value })}
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                name={`Url-${index}`}
                value={track.url}
                label="Url"
                fullWidth
                onChange={(e) => handleTrackChange(index, { url: e.target.value })}
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                name={`Duration-${index}`}
                value={track.duration}
                label="Duration"
                fullWidth
                onChange={(e) => handleTrackChange(index, { duration: e.target.value })}
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                name={`Order-${index}`}
                value={track.order}
                label="Order"
                fullWidth
                onChange={(e) => handleTrackChange(index, { order: e.target.value })}
              />
            </Grid>
            <Grid item xs={2}>
              <IconButton onClick={() => handleDeleteTrack(index)}>
                <DeleteIcon color="error" />
              </IconButton>
            </Grid>
          </Grid>
        </Box>
      </Grid>
    ))}

    {/* Button to add a new track */}
    <Grid item xs={12}>
      <Grid container justifyContent="center">
        <div style={{ textAlign: 'center', width: '100%' }}>
          <Typography variant="subtitle1">Add Track</Typography>
          <IconButton color="primary" onClick={handleAddTrack}>
            <AddIcon />
          </IconButton>
        </div>
      </Grid>
    </Grid>
  </Grid>
)}


                  <Box sx={{ display: 'flex', justifyContent: 'flex-end', marginTop: '20px' }}>
                  <Button
                    onClick={handleClose}
                    variant="outlined"
                    color="primary"
                    sx={{ marginRight: '10px' }}
                  >
                    Cancel
                  </Button>
                  <Button
                    onClick={handleSubmit}
                    variant="contained"
                    color="primary"
                  >
                    Submit
                  </Button>
                </Box>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </Container>
    </>
  );
};

export default AddAudio;
